<template>
  <header :class="['navbar-main', { scrolled: isScrolled }]">
    <div
      class="container d-flex justify-content-between align-items-center py-1 px-5"
    >
      <!-- Logo -->
      <router-link to="/" class="nav_logo logo-white-filter">
        <!-- :class="{ 'logo-white-filter': isScrolled }" -->
        <img
          src="@/assets/talento_agv/img/home/Logo-agv-color.svg"
          alt="Logo"
        />
      </router-link>

      <!-- Icon -->
      <button
        class="navbar-toggler d-lg-none border-0 bg-transparent"
        type="button"
        @click="toggleMobileMenu"
      >
        <i class="bx bx-menu fs-3 text-white"></i>
      </button>

      <!-- Navigation for desktop -->
      <nav
        class="d-none d-lg-flex gap-4 align-items-center text-white fw-semibold"
      >
        <template v-if="$route.path === '/'">
          <a href="#quienes-somos" class="nav-link text-white">
            {{ $t("Quiénes somos") }}
          </a>
        </template>
        <template v-else>
          <router-link to="/" class="nav-link text-white">
            {{ $t("Quiénes somos") }}
          </router-link>
        </template>
        <router-link to="/nuestra_cultura" class="nav-link text-white">{{
          $t("Nuestra Cultura")
        }}</router-link>
        <!-- <router-link to="/young_talent" class="nav-link text-white"
          >Programa Young Talent</router-link
        > -->
        <router-link to="/escuela_corporativa" class="nav-link text-white">{{
          $t("Escuela Corporativa")
        }}</router-link>

        <div class="dropdown">
          <button
            class="btn btn-sm text-white dropdown-toggle"
            data-bs-toggle="dropdown"
          >
            {{ textLenguage }}
          </button>
          <ul class="dropdown-menu">
            <li @click="changeLanguage('es')">
              <a class="dropdown-item"> ES | Español</a>
            </li>
            <li @click="changeLanguage('en')">
              <a class="dropdown-item">EN | English</a>
            </li>
          </ul>
        </div>

        <router-link
          to="/login"
          :class="[
            'btn',
            isScrolled ? 'btn-local-login active' : 'btn-local-login',
            'rounded-pill',
            'px-3',
          ]"
        >
          {{ $t("Iniciar Sesión") }}
        </router-link>
      </nav>
    </div>

    <!-- Navigation for Mobile -->
    <div v-if="isMobileMenuOpen" class="mobile-nav d-lg-none">
      <div class="container d-flex flex-column gap-3 py-3">
        <template v-if="$route.path === '/'">
          <a href="#quienes-somos" class="text-white" @click="closeMobileMenu">
            {{ $t("Quiénes somos") }}
          </a>
        </template>
        <template v-else>
          <router-link to="/" class="text-white" @click="closeMobileMenu">
            {{ $t("Quiénes somos") }}
          </router-link>
        </template>
        <router-link
          to="/nuestra_cultura"
          class="text-white"
          @click="closeMobileMenu"
          >{{ $t("Nuestra Cultura") }}</router-link
        >
        <router-link
          to="/young_talent"
          class="text-white"
          @click="closeMobileMenu"
          >{{ $t("Programa Young Talent") }}</router-link
        >
        <router-link
          to="/escuela_corporativa"
          class="text-white"
          @click="closeMobileMenu"
          >{{ $t("Escuela Corporativa") }}</router-link
        >
        <router-link
          to="/login"
          class="btn btn-light rounded-pill"
          @click="closeMobileMenu"
        >
          {{ $t("Iniciar Sesión") }}
        </router-link>
      </div>
    </div>
  </header>
</template>
<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";

const { locale } = useI18n();
const store = useStore();
const emit = defineEmits(["on-change-main-page"]);

// Variables
const isScrolled = ref(false);
const isMobileMenuOpen = ref(false);
const textLenguage = ref("ES");

// Methods
const toggleMobileMenu = () => {
  isMobileMenuOpen.value = !isMobileMenuOpen.value;
};

const closeMobileMenu = () => {
  isMobileMenuOpen.value = false;
};

const changeLanguage = async (language) => {
  textLenguage.value = language.toUpperCase();
  await store.dispatch("changePublicLanguage", language);
  locale.value = language;
  emit("on-change-main-page");
};

// Lifecycle hooks and dependent methods
const handleScroll = () => {
  isScrolled.value = window.scrollY > 50;
};

onMounted(() => {
  window.addEventListener("scroll", handleScroll);
});

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});
</script>
<style scoped>
.navbar-main {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  transition: background-color 0.3s ease;
  background-color: transparent;
  z-index: 1000;
}

.navbar-main.scrolled {
  background-color: var(--bg-primary-as);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.nav-link {
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  text-decoration: none;
}

.mobile-nav {
  background-color: var(--bg-primary-as);
  position: absolute;
  top: 100%;
  width: 100%;
}

.btn-local-login {
  background-color: var(--bg-primary-as);
  color: #fff;
  border: 1px solid transparent;
}
.btn-local-login.active {
  background-color: var(--bg-primary-as-light);
  border: 1px solid transparent;
}
.btn-local-login:hover {
  background-color: var(--bg-primary-as);
}
.btn-local-login.active:hover {
  background-color: var(--bg-primary-as-light);
}

.logo-white-filter {
  filter: brightness(0) invert(1);
}
</style>
